import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppVersion } from "@ionic-native/app-version";
import { FirebaseAnalytics } from "@ionic-native/firebase-analytics";
import { Storage } from "@ionic/storage";
import { Platform } from "ionic-angular";
import { handleMsgError } from "../../helpers/handle-error-message.helper";
import { AppPreferences } from "../../shared/local/app-preferences.local";

/*
  Generated class for the AnalyticsProvider provider.
  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
declare var ga: Function;

@Injectable()
export class AnalyticsProvider {
  viewsNotSent = [];
  eventsNotSent = [];
  userNotSent = [];
  exceptionNotSent = [];
  versionNumber: any;

  constructor(
    public http: HttpClient,
    public platform: Platform,
    public appVersion: AppVersion,
    public storage: Storage,
    private firebaseAnalytics: FirebaseAnalytics,
    private appPreferences: AppPreferences
  ) {

  }

  async setUserPropertyAnalytics() {
    try {
      await this.platform.ready();
      const auth = await this.appPreferences.getAuth();
      if (auth && auth.id) {
        const userId = auth.userId + auth.companyCode
        this.setUserIdFirebase(userId);
        this.setUserProperty('CompanyCode', auth.companyCode);
        this.setUserProperty('UserId', userId);
        this.setUserProperty('Email', auth.email);
        this.setUserProperty('FullName', auth.fullName);
      } else {
        this.setUserProperty('CompanyCode', 'not_login');
        this.setUserProperty('UserId', 'not_login');
        this.setUserProperty('Email', 'not_login');
        this.setUserProperty('FullName', 'not_login');
      }
    } catch (error) {
      console.log('TCL: setUserPropertyAnalytics error', error);
    }
  }

  // start analytics tacker
  startTrackerWithId(id) {
    if (!this.platform.is('cordova')) {
      ga("create", {
        storage: "none",
        trackingId: id,
        clientId: localStorage.getItem("ga:clientId")
      });

      ga("set", "checkProtocolTask", null);
      ga("set", "transportUrl", "https://www.google-analytics.com/collect");
      ga(function (tracker) {
        if (!localStorage.getItem("ga:clientId")) {
          localStorage.setItem("ga:clientId", tracker.get("clientId"));
        }
      });
    }
  }

  // track screen or page
  trackView(screenName) {
    if (screenName) {
      if (this.platform.is("cordova")) {
        this.setCurrentScreen(screenName);
      } else {
        ga("set", "page", screenName);
        ga("send", "pageview");
      }
    }
  }

  // track event
  async trackEvent(category: string, actionValue?: any, actionNumber?: number) {
    try {
      const action = category.split('_').join(' ');
      let value = '-';

      if (actionValue) {
        const message = handleMsgError(actionValue);
        const valueString = typeof message !== 'string' ? JSON.stringify(message) : message;
        value = valueString ? valueString.substring(0, 100) : '-';
      }

      if (this.platform.is("cordova")) {
        this.logEvent(category, { action, value, actionNumber })
      } else {
        ga("send", "event", {
          eventCategory: category,
          eventLabel: actionValue,
          eventAction: action,
          eventValue: value
        });
      }
    } catch (error) {
      console.log('TCL: error tracke event', error);
    }
  }

  setUserProperty(name, value) {
    if (this.platform.is('cordova')) {
      if (name && value) {
        this.firebaseAnalytics.setUserProperty(name, value)
          .then(res => console.log('setUserProperty', res))
          .catch(error => console.error('error setUserProperty', error));
      }
    }
  }

  async logEvent(name: string, params: any) {
    if (this.platform.is('cordova')) {
      await this.setUserPropertyAnalytics();
      const eventName = name.split(' ').join('_');
      if (eventName) {
        this.firebaseAnalytics.logEvent(eventName, params)
          .then(res => console.log('logEvent', res))
          .catch(error => console.error('error logEvent', error));
      }
    }
  }

  async setCurrentScreen(page: string) {
    if (this.platform.is('cordova')) {
      if (page) {
        await this.setUserPropertyAnalytics();
        this.firebaseAnalytics.setCurrentScreen(page)
          .then(res => console.log('setCurrentScreen', res))
          .catch(error => console.error('error setCurrentScreen', error));
      }
    }
  }

  setUserIdFirebase(userId) {
    if (this.platform.is('cordova')) {
      if (userId) {
        this.firebaseAnalytics.setUserId(userId)
          .then(res => console.log('setUserId', res))
          .catch(error => console.error('error setUserId', error));
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/analytics/analytics.ts